(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["prison-pdp-style"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  const states=new Map();
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const connection=navigator.connection||navigator.mozConnection||navigator.webkitConnection;
  const autoAllowed=()=>!reduced.matches&&!(connection&&connection.saveData);
  function init(root){
    root.querySelectorAll('[data-prison-style-video]').forEach(host=>{
      if(states.has(host))return;
      const video=host.querySelector('video');
      const button=host.querySelector('[data-prison-video-toggle]');
      if(!video||!button||!video.dataset.videoSrc)return;
      const s={video,button,visible:false,loaded:false,userPaused:false,manual:false,warm:null,view:null};
      states.set(host,s);
      video.muted=true;
      video.defaultMuted=true;
      video.controls=false;
      button.hidden=false;
      function load(){
        if(s.loaded)return;
        video.src=video.dataset.videoSrc;
        s.loaded=true;
        video.load();
      }
      function label(){
        const playing=!video.paused&&!video.ended;
        const text=playing?'Pausar vídeo':'Reproduzir vídeo';
        button.dataset.playing=String(playing);
        button.setAttribute('aria-label',text);
        button.title=text;
      }
      function play(){
        if(document.hidden||!s.visible||s.userPaused)return;
        load();
        const promise=video.play();
        if(promise&&promise.catch)promise.catch(label);
      }
      s.sync=()=>{
        if(document.hidden||!s.visible||s.userPaused||(!s.manual&&!autoAllowed()))video.pause();
        else play();
      };
      button.addEventListener('click',()=>{
        if(video.paused){s.userPaused=false;s.manual=true;s.visible=true;play();}
        else{s.userPaused=true;video.pause();}
      });
      video.addEventListener('play',()=>{if(document.hidden||!s.visible)video.pause();label();});
      video.addEventListener('pause',label);
      video.addEventListener('error',()=>{button.setAttribute('aria-label','Vídeo indisponível');button.title='Vídeo indisponível';button.disabled=true;});
      if('IntersectionObserver' in window){
        s.warm=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting&&autoAllowed()){load();s.warm.disconnect();}});},{rootMargin:'180px 0px'});
        s.warm.observe(host);
        s.view=new IntersectionObserver(entries=>{entries.forEach(entry=>{s.visible=entry.isIntersecting&&entry.intersectionRatio>=.15;s.sync();});},{threshold:[0,.15]});
        s.view.observe(host);
      }
      label();
    });
  }
  const syncAll=()=>states.forEach(s=>s.sync());
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
  document.addEventListener('visibilitychange',syncAll);
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>{states.forEach((s,host)=>{if(event.target.contains(host)){s.video.pause();if(s.warm)s.warm.disconnect();if(s.view)s.view.disconnect();states.delete(host);}});});
  if(reduced.addEventListener)reduced.addEventListener('change',syncAll);
  if(connection&&connection.addEventListener)connection.addEventListener('change',syncAll);
})();

  } catch(e) { console.error(e); }
})();
})();
